import axios from "./axiosConfig";

export const getCourses = async () => {
  try {
    const resp = await axios.get("/courses?visibility=true");
    return resp.data.data;
  } catch (e) {
    console.log(e);
  }
};

const courseServices = { getCourses };

export default courseServices;
